module.exports = __webpack_public_path__ + "img/image1-web.c045a95d.webp";